"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../context");
const Carousel_1 = tslib_1.__importDefault(require("../../../ui-lib/Carousel/Carousel"));
const ErrorBoundary_1 = require("../../ErrorBoundary");
const MultistreamCarouselSlide_1 = tslib_1.__importDefault(require("./MultistreamCarouselSlide"));
const useMediaQuery_1 = tslib_1.__importDefault(require("../../../ui-lib/Hooks/useMediaQuery"));
const MultistreamCarousel = (0, mobx_react_lite_1.observer)(({ itemsPerSlide = 6 }) => {
    const isTablet = (0, useMediaQuery_1.default)("screen and (max-width: 1023px)");
    const isMobile = (0, useMediaQuery_1.default)("screen and (max-width: 768px)");
    const ctx = (0, react_1.useContext)(context_1.MultistreamContext);
    (0, ErrorBoundary_1.useUndefinedStoreError)(ctx != null, "<MultistreamCarousel/>");
    const { isInitialLoadDone, publicKeys } = ctx;
    return (react_1.default.createElement("div", null, isInitialLoadDone && (react_1.default.createElement(Carousel_1.default, { itemsPerSlide: isTablet ? itemsPerSlide / 2 : itemsPerSlide, gap: 10, vertical: !isMobile }, publicKeys.map((publicKey) => (react_1.default.createElement(MultistreamCarouselSlide_1.default, { key: publicKey, publicKey: publicKey, isMobile: isMobile })))))));
});
exports.default = MultistreamCarousel;
//# sourceMappingURL=MultistreamCarousel.js.map